import BaseConfigJSON from 'config/base-config.json';
import Config from 'config/config.json';
import {BaseConfigInterface} from 'config/entity/BaseConfigInterface';

const BaseConfig: BaseConfigInterface = BaseConfigJSON;

export {BaseConfig, Config};
